import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type TakeLineItemAllocationsMutationVariables = Types.Exact<{
  input: Types.TakeLineItemAllocationsInput;
}>;


export type TakeLineItemAllocationsMutation = { __typename?: 'Mutation', takeLineItemAllocations: { __typename?: 'OrderPayload', errors?: Array<{ __typename?: 'ValidationError', message: string }> | null, order?: { __typename?: 'OrderStateData', tenantId: string, orderId: string, orderNumber: string, poNumber: string, type: Types.OrderType, status: Types.OrderStatus, orderEntryUnit: Types.OrderEntryUnit, priceEntryUnit: Types.PriceEntryUnit, finalCredit?: boolean | null, creditedFromOrderId?: string | null, creditedFromOrderNumber?: string | null, produceAllocate?: boolean | null, discountPercent: number, discountAmount: number, discountReason: string, overrideTotal?: number | null, adjustedAt: Types.TDateISO, adjustedBy: string, verifiedBy: string, verifiedAt?: Types.TDateISO | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, freightChargeAmount: number, freightSource: Types.FreightSource, freightChargeReason: string, flatChargesTotal: number, freightAdjustedBy: string, freightAdjustedAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, initializationDate: Types.TDateISO, erpId: string, salesPerson: string, termsId: string, route: string, containerCode: string, program?: string | null, orderKindId?: string | null, orderKindName?: string | null, carrier: string, termsDiscountMessage?: string | null, subtotal: number, total: number, customerTotal: number, invoiceStatus: Types.OrderInvoiceStatus, submittedAt?: Types.TDateISO | null, sendOrderEmails?: boolean | null, effectiveSendOrderEmails: boolean, effectiveInvoiceReportId: string, effectiveAcknowledgementReportId: string, effectivePullSlipReportId: string, sendInvoiceEmails?: boolean | null, nonDiscountableSubtotal: number, shipFromSiteLocationId: string, correction?: { __typename?: 'OrderCorrectionData', counterpartOrderId: string, role: Types.OrderCorrectionRole, sourceOrderId: string, sourceOrderNumber: string } | null, freightProvenance?: { __typename?: 'LoadFreightProvenanceData', contributions: Array<{ __typename?: 'LoadFreightContributionData', loadId: string, containers: number, share: number, surchargePercent: number }> } | null, flatCharges: Array<{ __typename?: 'OrderFlatChargeData', id: string, kind: Types.OrderFlatChargeKind, flatChargeTypeId?: string | null, name: string, amount: number, taxable: boolean, basis?: string | null, reason: string }>, confirmationEmails: Array<{ __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string }>, estimatedTax?: { __typename?: 'OrderTaxEstimatePayload', amount: number, estimatedAt?: Types.TDateISO | null, status: Types.OrderTaxEstimateStatus, breakdown: Array<{ __typename?: 'OrderTaxEstimateJurisdictionPayload', jurisdiction: string, level: string, state?: string | null, rate: number, amount: number, taxableAmount: number, reason: string }> } | null, noTax?: { __typename?: 'OrderNoTaxData', reason: Types.CustomerTaxExemptionReason, note?: string | null, setBy: string, setAt: Types.TDateISO } | null, exemptingCertificate?: { __typename?: 'CustomerTaxExemption', state?: string | null, reason?: Types.CustomerTaxExemptionReason | null, expiresOn?: string | null } | null, syncAttempts: Array<{ __typename?: 'SyncAttemptData', success: boolean }>, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }>, categoryVolumeDiscounts: Array<{ __typename?: 'OrderCategoryVolumeDiscountData', categoryCode: string, categoryName: string, qualifyingQuantity: number, discountedQuantity: number, matchedThreshold: number, tierPrice?: number | null, amount: number, qualifiedNotDiscountedQuantity: number, qualifiedNotDiscountedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }>, lines: Array<{ __typename?: 'OrderCategoryVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, linePrice: number, tierPrice: number, amount: number }> }>, categoryVolumeProgress: Array<{ __typename?: 'OrderCategoryVolumeProgressData', categoryCode: string, categoryName: string, qualifyingQuantity: number, qualified: boolean, matchedThreshold?: number | null, matchedTierPrice?: number | null, nextThreshold?: number | null, nextTierPrice?: number | null, quantityToNextThreshold?: number | null, excludedQuantity: number, excludedByReason: Array<{ __typename?: 'OrderCategoryVolumeExclusionData', reason: Types.CategoryVolumeExclusionReason, quantity: number }> }>, volumePoolProgress: Array<{ __typename?: 'OrderVolumePoolProgressData', poolId: string, pooledQuantity: number, nextBreakQuantity?: number | null, linesAtBreak: number, participatingLineCount: number, code: string, name: string }>, orderVolumeDiscount?: { __typename?: 'OrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, threshold: number, qualifyingUnits: number, qualifyingSubtotal: number, valueType: Types.OrderVolumeDiscountValueType, configuredValue: number, uncappedAmount: number, amount: number, lines: Array<{ __typename?: 'OrderVolumeLineData', lineItemId: string, lineNumber: number, itemId: string, quantity: number, lineBase: number, amount: number }> } | null, nonDiscountableLines: Array<{ __typename?: 'OrderNonDiscountableLineData', lineItemId: string, lineNumber: number, itemId: string, lineSubtotal: number }>, discountBreakdown: Array<{ __typename?: 'OrderDiscountComponentData', kind: Types.OrderDiscountComponentKind, label: string, categoryCode?: string | null, amount: number }>, signatureImage?: { __typename?: 'SignatureImageData', image: string, mime: string, firstName: string, lastName: string, dateCaptured: Types.TDateISO } | null, customer: { __typename?: 'OrderCustomerData', id: string, erpId?: string | null, name: string, billToAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, location: { __typename?: 'LocationData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, locationLookupCode?: string | null, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, termsName?: string | null, route?: string | null, carrier?: string | null, allowOrderBillingAddressEdit?: boolean | null, allowOrderLocationAddressEdit?: boolean | null, freightChargeType?: Types.FreightChargeType | null, freightChargeValue?: number | null, sendOrderEmails?: boolean | null, sendInvoiceEmails?: boolean | null, poRequired?: boolean | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }>, settings?: { __typename?: 'CustomerLocationSettingsData', deliveryScheduleId?: string | null, retailerName: string, route?: string | null, shippingNotes?: string | null, storeClass: string, zone: string, ruleIds: Array<string>, notes?: Array<{ __typename?: 'NoteData', id: string, submitDate: Types.TDateISO, submittedBy: string, noteText: string }> | null } | null }, contact: { __typename?: 'OrderContactData', type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumber: { __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }, emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } } }, shipFromLocation: { __typename?: 'ShipFromLocationData', name: string }, lineItems: Array<{ __typename?: 'LineItemData', unitPrice: number, overrideUnitPrice?: number | null, acknowledgedEaches?: number | null, acknowledgedQuantity?: number | null, acknowledgedZeroBillsNothing: boolean, addedBy: string, available: number, category?: string | null, containerCode?: string | null, cost: number, creditableEaches: number, creditedEaches: number, currency: string, dateAdded: Types.TDateISO, eaches: number, eachesQuantity?: number | null, id: string, itemGroup?: string | null, itemId: string, kitGroupId?: string | null, kitId?: string | null, lineNumber: number, name: string, orderedQuantity?: number | null, overridePrice?: number | null, price: number, quantity?: number | null, handlingUom?: number | null, royaltyExempt: boolean, shippedQuantity?: number | null, shippedZeroBillsNothing: boolean, shippingConfigCategoryCode?: string | null, shippingUomId?: string | null, eachesPerUnit?: number | null, orderedUnits?: number | null, orderedEaches?: number | null, allocatedUnits?: number | null, acknowledgedUnits?: number | null, shippedUnits?: number | null, resolvedEachesPerUnit: number, stageBasisQuantity: number, billableEaches: number, upgradeSubtotalAdjustment: number, lineSubtotal: number, sku: string, upc: string, customerItemId?: string | null, customerSku?: string | null, customerUpc?: string | null, tag1Locked: boolean, tag2Locked: boolean, fulfillmentSource: Types.FulfillmentSource, productionCatalogId?: string | null, productionCategoryId?: string | null, volumePoolId?: string | null, availableByLocation: Array<{ __typename?: 'ItemAvailabilityByLocationData', locationId: string, grade: number, quantity: number }>, note?: { __typename?: 'LineItemNoteData', noteText: string, submitDate: Types.TDateISO, submittedBy: string } | null, notes: Array<{ __typename?: 'LineItemContextNoteData', context: Types.NoteContext, text: string, submitDate: Types.TDateISO, submittedBy: string }>, royalty?: { __typename?: 'LineItemRoyaltyData', rateType: Types.RoyaltyRateType, rate: number, payeeName: string, amount: number } | null, upgrades: Array<{ __typename?: 'OrderLineUpgradeData', lineItemUpgradeId: string, sourceItemUpgradeId?: string | null, name: string, categoryLabel?: string | null, source: Types.OrderLineUpgradeSource, pricing: { __typename?: 'ItemUpgradePricing', mode: Types.PricingMode, flatPrice?: number | null, markupPercent?: number | null } }> }>, allocations: Array<{ __typename?: 'AllocationItemData', lineItemId: string, itemId: string, locationId?: string | null, grade: number, quantity: number, allocatedBy: string, allocatedAt: Types.TDateISO }>, pulls: Array<{ __typename?: 'OrderLinePull', pullId: string, lineItemId: string, itemId: string, locationId: string, locationName?: string | null, grade: number, quantity: number, pulledBy: string, pulledAt: Types.TDateISO }>, allocationTakes: Array<{ __typename?: 'OrderAllocationTake', lineItemId: string, itemId: string, itemName?: string | null, locationId: string, locationName?: string | null, grade: number, quantity: number, direction: Types.AllocationTakeDirection, otherOrderId: string, otherOrderNumber?: string | null, otherCustomerName?: string | null, allocatedBefore?: number | null, allocatedAfter?: number | null, takenBy: string, takenAt: Types.TDateISO }>, dropShipDestination?: { __typename?: 'OrderDropShipDestinationData', shipToName: string, addressLine1: string, city: string, stateProvince: string, zipcode: string, latitude?: number | null, longitude?: number | null, deliveryNotes?: string | null, phone?: string | null } | null, hold?: { __typename?: 'OrderHold', reason: string, placedBy: string, placedAt: Types.TDateISO } | null } | null, warnings?: Array<{ __typename?: 'OverAllocationWarningData', itemId: string, locationId: string, grade: number, requestedQuantity: number, availableQuantity: number }> | null } };


export const TakeLineItemAllocationsDocument = new TypedDocumentString(`
    mutation TakeLineItemAllocations($input: TakeLineItemAllocationsInput!) {
  takeLineItemAllocations(input: $input) {
    errors {
      message
    }
    order {
      ...OrderDetails
    }
    warnings {
      ...OverAllocationWarning
    }
  }
}
    fragment OrderDetails on OrderStateData {
  tenantId
  orderId
  orderNumber
  poNumber
  type
  status
  orderEntryUnit
  priceEntryUnit
  finalCredit
  creditedFromOrderId
  creditedFromOrderNumber
  correction {
    ...OrderCorrectionLink
    counterpartOrderId
  }
  produceAllocate
  discountPercent
  discountAmount
  discountReason
  overrideTotal
  adjustedAt
  adjustedBy
  verifiedBy
  verifiedAt
  freightChargeType
  freightChargeValue
  freightChargeAmount
  freightSource
  freightProvenance {
    contributions {
      loadId
      containers
      share
      surchargePercent
    }
  }
  freightChargeReason
  flatCharges {
    ...OrderFlatCharge
  }
  flatChargesTotal
  freightAdjustedBy
  freightAdjustedAt
  expectedDeliveryDate
  initializationDate
  confirmationEmails {
    sent
    toEmail
  }
  erpId
  salesPerson
  termsId
  route
  containerCode
  program
  orderKindId
  orderKindName
  carrier
  termsDiscountMessage
  subtotal
  total
  customerTotal
  estimatedTax {
    ...OrderTaxEstimateSummary
  }
  noTax {
    reason
    note
    setBy
    setAt
  }
  exemptingCertificate {
    state
    reason
    expiresOn
  }
  syncAttempts {
    success
  }
  invoiceStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  submittedAt
  sendOrderEmails
  effectiveSendOrderEmails
  effectiveInvoiceReportId
  effectiveAcknowledgementReportId
  effectivePullSlipReportId
  sendInvoiceEmails
  categoryVolumeDiscounts {
    ...OrderCategoryVolumeDiscount
  }
  categoryVolumeProgress {
    ...OrderCategoryVolumeProgress
  }
  volumePoolProgress {
    ...OrderVolumePoolProgress
  }
  orderVolumeDiscount {
    ...OrderVolumeDiscount
  }
  nonDiscountableLines {
    ...OrderNonDiscountableLine
  }
  nonDiscountableSubtotal
  discountBreakdown {
    ...OrderDiscountComponent
  }
  signatureImage {
    image
    mime
    firstName
    lastName
    dateCaptured
  }
  customer {
    id
    erpId
    name
    billToAddress {
      ...AddressData
    }
    location {
      ...Location
    }
    contact {
      type
      firstName
      lastName
      title
      phoneNumber {
        type
        value
      }
      emailAddress {
        type
        value
      }
    }
  }
  shipFromLocation {
    name
  }
  shipFromSiteLocationId
  lineItems {
    ...LineItem
  }
  signatureImage {
    dateCaptured
    firstName
    image
    lastName
    mime
  }
  allocations {
    lineItemId
    itemId
    locationId
    grade
    quantity
    allocatedBy
    allocatedAt
  }
  pulls {
    pullId
    lineItemId
    itemId
    locationId
    locationName
    grade
    quantity
    pulledBy
    pulledAt
  }
  allocationTakes {
    lineItemId
    itemId
    itemName
    locationId
    locationName
    grade
    quantity
    direction
    otherOrderId
    otherOrderNumber
    otherCustomerName
    allocatedBefore
    allocatedAfter
    takenBy
    takenAt
  }
  dropShipDestination {
    ...OrderDropShipDestinationFields
  }
  hold {
    reason
    placedBy
    placedAt
  }
}
fragment OrderCorrectionLink on OrderCorrectionData {
  role
  sourceOrderId
  sourceOrderNumber
}
fragment OrderFlatCharge on OrderFlatChargeData {
  id
  kind
  flatChargeTypeId
  name
  amount
  taxable
  basis
  reason
}
fragment OrderTaxEstimateSummary on OrderTaxEstimatePayload {
  amount
  breakdown {
    jurisdiction
    level
    state
    rate
    amount
    taxableAmount
    reason
  }
  estimatedAt
  status
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment OrderCategoryVolumeDiscount on OrderCategoryVolumeDiscountData {
  categoryCode
  categoryName
  qualifyingQuantity
  discountedQuantity
  matchedThreshold
  tierPrice
  amount
  qualifiedNotDiscountedQuantity
  qualifiedNotDiscountedByReason {
    ...OrderCategoryVolumeExclusion
  }
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    linePrice
    tierPrice
    amount
  }
}
fragment OrderCategoryVolumeExclusion on OrderCategoryVolumeExclusionData {
  reason
  quantity
}
fragment OrderCategoryVolumeProgress on OrderCategoryVolumeProgressData {
  categoryCode
  categoryName
  qualifyingQuantity
  qualified
  matchedThreshold
  matchedTierPrice
  nextThreshold
  nextTierPrice
  quantityToNextThreshold
  excludedQuantity
  excludedByReason {
    ...OrderCategoryVolumeExclusion
  }
}
fragment OrderVolumePoolProgress on OrderVolumePoolProgressData {
  poolId
  pooledQuantity
  nextBreakQuantity
  linesAtBreak
  participatingLineCount
  code
  name
}
fragment OrderVolumeDiscount on OrderVolumeDiscountData {
  thresholdType
  threshold
  qualifyingUnits
  qualifyingSubtotal
  valueType
  configuredValue
  uncappedAmount
  amount
  lines {
    lineItemId
    lineNumber
    itemId
    quantity
    lineBase
    amount
  }
}
fragment OrderNonDiscountableLine on OrderNonDiscountableLineData {
  lineItemId
  lineNumber
  itemId
  lineSubtotal
}
fragment OrderDiscountComponent on OrderDiscountComponentData {
  kind
  label
  categoryCode
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Location on LocationData {
  id
  code
  storeNumber
  name
  description
  region
  market
  adGroup
  globalLocationNumber
  locationLookupCode
  priceGroupId
  priceGroupName
  termsId
  termsName
  route
  carrier
  allowOrderBillingAddressEdit
  allowOrderLocationAddressEdit
  freightChargeType
  freightChargeValue
  sendOrderEmails
  sendInvoiceEmails
  poRequired
  address {
    ...Address
  }
  salesPeople {
    ...SalesPerson
  }
  settings {
    deliveryScheduleId
    retailerName
    route
    shippingNotes
    storeClass
    zone
    notes {
      id
      submitDate
      submittedBy
      noteText
    }
    ruleIds
  }
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}
fragment LineItem on LineItemData {
  unitPrice
  overrideUnitPrice
  acknowledgedEaches
  acknowledgedQuantity
  acknowledgedZeroBillsNothing
  addedBy
  available
  availableByLocation {
    locationId
    grade
    quantity
  }
  category
  containerCode
  cost
  creditableEaches
  creditedEaches
  currency
  dateAdded
  eaches
  eachesQuantity
  id
  itemGroup
  itemId
  kitGroupId
  kitId
  lineNumber
  name
  note {
    noteText
    submitDate
    submittedBy
  }
  notes {
    context
    text
    submitDate
    submittedBy
  }
  orderedQuantity
  overridePrice
  price
  quantity
  handlingUom
  royaltyExempt
  royalty {
    ...LineItemRoyalty
  }
  shippedQuantity
  shippedZeroBillsNothing
  shippingConfigCategoryCode
  shippingUomId
  eachesPerUnit
  orderedUnits
  orderedEaches
  allocatedUnits
  acknowledgedUnits
  shippedUnits
  resolvedEachesPerUnit
  stageBasisQuantity
  billableEaches
  upgradeSubtotalAdjustment
  lineSubtotal
  sku
  upc
  customerItemId
  customerSku
  customerUpc
  tag1Locked
  tag2Locked
  royaltyExempt
  fulfillmentSource
  productionCatalogId
  productionCategoryId
  volumePoolId
  upgrades {
    ...OrderLineUpgrade
  }
}
fragment LineItemRoyalty on LineItemRoyaltyData {
  rateType
  rate
  payeeName
  amount
}
fragment OrderLineUpgrade on OrderLineUpgradeData {
  lineItemUpgradeId
  sourceItemUpgradeId
  name
  categoryLabel
  source
  pricing {
    mode
    flatPrice
    markupPercent
  }
}
fragment OrderDropShipDestinationFields on OrderDropShipDestinationData {
  shipToName
  addressLine1
  city
  stateProvince
  zipcode
  latitude
  longitude
  deliveryNotes
  phone
}
fragment OverAllocationWarning on OverAllocationWarningData {
  itemId
  locationId
  grade
  requestedQuantity
  availableQuantity
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    TakeLineItemAllocations: build.mutation<TakeLineItemAllocationsMutation, TakeLineItemAllocationsMutationVariables>({
      query: (variables) => ({ document: TakeLineItemAllocationsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useTakeLineItemAllocationsMutation } = injectedRtkApi;
